import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {OrderDetailsWidgetImplementation} from './order-details-widget-implementation';
import {ORDER_DETAILS_WIDGET_TYPE_ID} from './order-details-widget-type-id';
import {OrderDetailsWidgetComponent} from './order-details-widget.component';
import {OrderDetailsWidgetSettingsService} from './settings';

export const ORDER_DETAILS_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:                ORDER_DETAILS_WIDGET_TYPE_ID,
    widgetLabel:                 'components.widgets.order-details-widget.widget_name',
    widgetImplementationType:    OrderDetailsWidgetImplementation,
    widgetComponentType:         OrderDetailsWidgetComponent,
    widgetSettingsServiceType:   OrderDetailsWidgetSettingsService,
    settingsSchema:              [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          false,
    widgetSettingsComponentType: null,
    defaultWidgetSize:           [568, 498] // The size in pixels is got by measuring the widget's outer DOM element.
};
